module.exports = __webpack_public_path__ + "img/progress.3c7a6811.png";